import React from "react";
import { Link } from "react-router-dom";
import { jobCatalog } from "../data/jobs";
import Icon from "./Icon";

export default function JobContact({ jobId }) {
    const job = jobCatalog.find((item) => item.id === jobId);
    return (
        <aside className="job-contact">
            <span className="eyebrow">LAAT VAN JE HOREN</span>
            <h2>Klinkt dit als jouw volgende stap?</h2>
            <p>
                Stuur je motivatie en cv naar hr@smithtechniek.nl. We maken
                graag kennis met je.
            </p>
            <a
                className="button button-orange"
                href={`mailto:hr@smithtechniek.nl?subject=${encodeURIComponent(`Sollicitatie ${job.title}`)}`}
            >
                Solliciteer op deze functie <Icon />
            </a>
            <Link to="/#vacatures" className="text-link">
                Bekijk alle vacatures <Icon />
            </Link>
        </aside>
    );
}
